import { defineStore } from 'pinia'
import repository from '../api/repository'

export const useWhatsAppAccountStore = defineStore('whatsappAccount', {
  state: () => ({
    accounts: [],
    defaultPhoneNumberId: null,
    loaded: false,
  }),
  actions: {
    async loadAccounts() {
      if (this.loaded) return this.accounts

      try {
        const response = await repository.whatsappAccounts()
        const data = response?.data?.data
        this.accounts = data?.accounts || []
        this.defaultPhoneNumberId = data?.defaultPhoneNumberId || null
      } catch (error) {
        console.error('Unable to load WhatsApp sender accounts:', error)
        this.accounts = []
        this.defaultPhoneNumberId = null
      } finally {
        this.loaded = this.accounts.length > 0
      }
      return this.accounts
    },
  },
})
